export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type AdditionalDeliveryField = {
  __typename?: 'AdditionalDeliveryField';
  name: Maybe<Scalars['String']['output']>;
};

export type AutoSellConfig = {
  __typename?: 'AutoSellConfig';
  organizationId: Maybe<Scalars['ID']['output']>;
  verificationMode: Maybe<AutoSellOrderVerificationMode>;
  verifyOrders: Maybe<Scalars['Boolean']['output']>;
};

export enum AutoSellOrderVerificationMode {
  All = 'All',
  None = 'None',
  WithComment = 'WithComment',
}

export type CoverSetup = {
  __typename?: 'CoverSetup';
  coverSetupId: Maybe<Scalars['ID']['output']>;
  file: Maybe<Scalars['String']['output']>;
  size: Maybe<CoverSize>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type CoverSize = {
  __typename?: 'CoverSize';
  h: Maybe<Scalars['Int']['output']>;
  w: Maybe<Scalars['Int']['output']>;
};

export type CoverSizeInput = {
  h: Scalars['Int']['input'];
  w: Scalars['Int']['input'];
};

export type CoverUpdateDetails = {
  file: Scalars['String']['input'];
  size: CoverSizeInput;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CustomLabel = {
  __typename?: 'CustomLabel';
  language: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type CustomLabelInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type DeliveryMethod = {
  __typename?: 'DeliveryMethod';
  additionalFields: Maybe<Array<Maybe<AdditionalDeliveryField>>>;
  addressRequired: Maybe<Scalars['Boolean']['output']>;
  context: Maybe<Array<Maybe<DeliveryMethodContext>>>;
  countryId: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['String']['output']>;
  deliveryMethodId: Maybe<Scalars['ID']['output']>;
  easyPackOrgId: Maybe<Scalars['ID']['output']>;
  easyPackToken: Maybe<Scalars['ID']['output']>;
  freeFrom: Maybe<Scalars['Float']['output']>;
  label: Maybe<Scalars['String']['output']>;
  mightBeFree: Maybe<Scalars['Boolean']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  phoneRequired: Maybe<Scalars['Boolean']['output']>;
  pickupAddress: Maybe<Scalars['String']['output']>;
  pickupNote: Maybe<Scalars['String']['output']>;
  preOrderNote: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<DeliveryType>;
};

export enum DeliveryMethodContext {
  EmbedStore = 'EmbedStore',
  Lab = 'Lab',
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  Wedding = 'Wedding',
}

export type DeliveryMethodForDisplay = {
  __typename?: 'DeliveryMethodForDisplay';
  additionalFields: Maybe<Array<Maybe<AdditionalDeliveryField>>>;
  addressRequired: Maybe<Scalars['Boolean']['output']>;
  countryId: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['String']['output']>;
  deliveryMethodId: Maybe<Scalars['ID']['output']>;
  freeFrom: Maybe<Scalars['Float']['output']>;
  isAutoSell: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<Scalars['String']['output']>;
  mightBeFree: Maybe<Scalars['Boolean']['output']>;
  phoneRequired: Maybe<Scalars['Boolean']['output']>;
  pickupAddress: Maybe<Scalars['String']['output']>;
  pickupNote: Maybe<Scalars['String']['output']>;
  preOrderNote: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<DeliveryType>;
};

export enum DeliveryType {
  Courier = 'Courier',
  Digital = 'Digital',
  EasyPack24 = 'EasyPack24',
  Pickup = 'Pickup',
}

export type FilePricing = {
  __typename?: 'FilePricing';
  filePricingId: Maybe<Scalars['String']['output']>;
  isFull: Maybe<Scalars['Boolean']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printsIncluded: Maybe<Array<Maybe<PrintsCount>>>;
  size: Maybe<Scalars['Int']['output']>;
  stepPricing: Maybe<StepPricing>;
  stepPricingEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type FilePricingInput = {
  filePricingId: Scalars['String']['input'];
  isFull: Scalars['Boolean']['input'];
  price: Array<InputMaybe<PriceConfigInput>>;
  printsIncluded: Array<InputMaybe<UpdatePrintsCount>>;
  size: Scalars['Int']['input'];
  stepPricing: StepPricingInput;
  stepPricingEnabled: Scalars['Boolean']['input'];
};

export enum FilesAndPrintsPackageType {
  AnyImage = 'AnyImage',
  OneImage = 'OneImage',
  PickedImage = 'PickedImage',
}

export type FilesConfig = {
  __typename?: 'FilesConfig';
  count: Maybe<Scalars['Int']['output']>;
  isFull: Maybe<Scalars['Boolean']['output']>;
  size: Maybe<Scalars['Int']['output']>;
};

export type ForcedImageConfig = {
  __typename?: 'ForcedImageConfig';
  photoGroupId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export type ImageForDisplay = {
  __typename?: 'ImageForDisplay';
  height: Maybe<Scalars['Int']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoGroupHasPhotoId: Scalars['String']['output'];
  photoGroupId: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type KeywordsList = {
  __typename?: 'KeywordsList';
  keywordsListId: Maybe<Scalars['ID']['output']>;
  list: Maybe<Array<Maybe<PhotoKeywords>>>;
};

export type LookBookWallDecorProducts = {
  __typename?: 'LookBookWallDecorProducts';
  labProducts: Maybe<Array<Maybe<Product>>>;
  labsInPlay: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  zalamoStandaloneTambour: Maybe<Product>;
  zalamoStandaloneWallDecor: Maybe<Product>;
};

export type Mutation = {
  __typename?: 'Mutation';
  updateMock: Maybe<Scalars['Int']['output']>;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type NumberRange = {
  __typename?: 'NumberRange';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type PhotoKeywords = {
  __typename?: 'PhotoKeywords';
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type PriceConfig = {
  __typename?: 'PriceConfig';
  code: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
};

export type PriceConfigInput = {
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
};

export type PriceStep = {
  __typename?: 'PriceStep';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  step: Maybe<Scalars['Int']['output']>;
};

export type PriceStepInput = {
  price: Array<InputMaybe<PriceConfigInput>>;
  step: Scalars['Int']['input'];
};

export type PrintAndFileConfig = {
  __typename?: 'PrintAndFileConfig';
  filesConfig: Maybe<Array<Maybe<FilesConfig>>>;
  forcedImage: Maybe<ForcedImageConfig>;
  groups: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mode: Maybe<FilesAndPrintsPackageType>;
  printAndFileConfigId: Maybe<Scalars['ID']['output']>;
  printsCount: Maybe<Array<Maybe<PrintsCount>>>;
};

export type PrintFormat = {
  __typename?: 'PrintFormat';
  label: Maybe<Scalars['String']['output']>;
  printFormatId: Maybe<Scalars['ID']['output']>;
};

export type PrintPaper = {
  __typename?: 'PrintPaper';
  label: Maybe<Scalars['String']['output']>;
  printPaperId: Maybe<Scalars['ID']['output']>;
};

export type PrintPriceConfig = {
  __typename?: 'PrintPriceConfig';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printFormatId: Maybe<Scalars['ID']['output']>;
  printPaperId: Maybe<Scalars['ID']['output']>;
  stepPricing: Maybe<StepPricing>;
  stepPricingEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type PrintsConfig = {
  __typename?: 'PrintsConfig';
  formats: Maybe<Array<Maybe<PrintFormat>>>;
  papers: Maybe<Array<Maybe<PrintPaper>>>;
};

export type PrintsCount = {
  __typename?: 'PrintsCount';
  count: Maybe<Scalars['Int']['output']>;
  printFormatId: Maybe<Scalars['String']['output']>;
  printPaperId: Maybe<Scalars['String']['output']>;
};

export enum PrintsPricingContext {
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  PublicSessionGroup = 'PublicSessionGroup',
  WeddingCouple = 'WeddingCouple',
  WeddingGallery = 'WeddingGallery',
}

export type PrintsPricingList = {
  __typename?: 'PrintsPricingList';
  context: Maybe<PrintsPricingContext>;
  label: Maybe<Scalars['String']['output']>;
  prices: Maybe<Array<Maybe<PrintPriceConfig>>>;
  printsPricingListId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type PrintsPricingListForDisplay = {
  __typename?: 'PrintsPricingListForDisplay';
  list: Maybe<Array<Maybe<PrintPriceConfig>>>;
  printsPricingListForDisplayId: Maybe<Scalars['ID']['output']>;
};

export type Product = {
  __typename?: 'Product';
  availableOnOccasion: Maybe<Array<Maybe<SessionOccasion>>>;
  composedImages: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  configurationImages: Maybe<Scalars['String']['output']>;
  deliveryTime: Maybe<Scalars['Int']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  hasTaxConfig: Maybe<Scalars['Boolean']['output']>;
  hasWizard: Maybe<Scalars['Boolean']['output']>;
  imagesRequired: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productId: Maybe<Scalars['ID']['output']>;
  requiredImages: Maybe<NumberRange>;
  showDeliveryTime: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taxConfig: Maybe<ProductTaxConfig>;
  type: Maybe<ProductType>;
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  config: Maybe<Scalars['String']['output']>;
  customName: Maybe<Array<Maybe<CustomLabel>>>;
  icon: Maybe<Scalars['String']['output']>;
  mode: Maybe<ProductMode>;
  productId: Maybe<Scalars['String']['output']>;
  productInPackageId: Maybe<Scalars['String']['output']>;
  qty: Maybe<Scalars['Int']['output']>;
};

export type ProductForDisplay = {
  __typename?: 'ProductForDisplay';
  availableOnOccasion: Maybe<Array<Maybe<SessionOccasion>>>;
  composedImages: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  configurationImages: Maybe<Scalars['String']['output']>;
  deliveryTime: Maybe<Scalars['Int']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  hasWizard: Maybe<Scalars['Boolean']['output']>;
  imagesRequired: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productId: Maybe<Scalars['ID']['output']>;
  requiredImages: Maybe<NumberRange>;
  showDeliveryTime: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<ProductType>;
};

export enum ProductMode {
  AllImagesFromPackage = 'AllImagesFromPackage',
  AnyImages = 'AnyImages',
  AnyImagesFromPackage = 'AnyImagesFromPackage',
}

export type ProductPackage = {
  __typename?: 'ProductPackage';
  allowMultiple: Maybe<Scalars['Boolean']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printAndFileConfig: Maybe<Array<Maybe<PrintAndFileConfig>>>;
  productConfig: Maybe<Array<Maybe<ProductConfig>>>;
  productPackageId: Maybe<Scalars['ID']['output']>;
};

export type ProductTaxConfig = {
  __typename?: 'ProductTaxConfig';
  label: Maybe<Scalars['String']['output']>;
  vatRate: Maybe<Scalars['Int']['output']>;
};

export type ProductTaxConfigInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductToProductRelation = {
  __typename?: 'ProductToProductRelation';
  id: Maybe<Scalars['String']['output']>;
  labId: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['String']['output']>;
  productId: Maybe<Scalars['String']['output']>;
  type: Maybe<ProductToProductRelationType>;
  value: Maybe<Scalars['String']['output']>;
};

export enum ProductToProductRelationType {
  Attribute = 'Attribute',
  Lab = 'Lab',
  Option = 'Option',
  Product = 'Product',
}

export enum ProductType {
  Album = 'Album',
  AlbumSet2plusOne = 'AlbumSet2plusOne',
  AlbumSetTriple = 'AlbumSetTriple',
  AlbumWithAcrylicPicture = 'AlbumWithAcrylicPicture',
  Book = 'Book',
  Calendar = 'Calendar',
  Canvas = 'Canvas',
  EconomicTwoPageTablo = 'EconomicTwoPageTablo',
  FatPrint = 'FatPrint',
  Frame = 'Frame',
  IdentityPhoto = 'IdentityPhoto',
  MagnetSticker = 'MagnetSticker',
  Mug = 'Mug',
  Other = 'Other',
  Prints = 'Prints',
  Tablo = 'Tablo',
  Tambour = 'Tambour',
  Triplex = 'Triplex',
  Wallart = 'Wallart',
  ZalamoCalendar = 'ZalamoCalendar',
  ZalamoEconomicTwoPageTablo = 'ZalamoEconomicTwoPageTablo',
  ZalamoMagnet = 'ZalamoMagnet',
  ZalamoPremiumTwoPageTablo = 'ZalamoPremiumTwoPageTablo',
}

export type Query = {
  __typename?: 'Query';
  getAvailableWallDecorConfigs: Maybe<Array<Maybe<WallDecorConfig>>>;
  getAvailableWallDecorScenes: Maybe<Array<Maybe<WallDecorSceneForDisplay>>>;
  getWallDecorLookBookConfigForPublicSession: Maybe<LookBookWallDecorProducts>;
  getWallDecorsLookBookConfigForPrivateSession: Maybe<LookBookWallDecorProducts>;
  mock: Maybe<Scalars['String']['output']>;
};

export type QueryGetWallDecorLookBookConfigForPublicSessionArgs = {
  publicSessionId: Scalars['ID']['input'];
};

export type QueryGetWallDecorsLookBookConfigForPrivateSessionArgs = {
  privateSessionId: Scalars['ID']['input'];
};

export type QuickLink = {
  __typename?: 'QuickLink';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  link: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quickLinkId: Maybe<Scalars['ID']['output']>;
};

export type RetouchLevel = {
  __typename?: 'RetouchLevel';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  retouchLevelId: Maybe<Scalars['ID']['output']>;
};

export enum SessionOccasion {
  Baphthism = 'Baphthism',
  Birthday = 'Birthday',
  FirstBirthday = 'FirstBirthday',
  FirstCommunion = 'FirstCommunion',
  Newborn = 'Newborn',
  Wedding = 'Wedding',
}

export type SoldFilesUniversalWatermarkConfig = {
  __typename?: 'SoldFilesUniversalWatermarkConfig';
  horizontal: Maybe<SoldFilesWatermarkConfig>;
  soldFilesUniversalWatermarkConfigId: Maybe<Scalars['ID']['output']>;
  vertical: Maybe<SoldFilesWatermarkConfig>;
};

export type SoldFilesWatermarkConfig = {
  __typename?: 'SoldFilesWatermarkConfig';
  alpha: Maybe<Scalars['Float']['output']>;
  config: Maybe<SoldFilesWatermarkConfigPosition>;
  file: Maybe<Scalars['String']['output']>;
  soldFilesWatermarkConfigId: Maybe<Scalars['ID']['output']>;
};

export type SoldFilesWatermarkConfigPosition = {
  __typename?: 'SoldFilesWatermarkConfigPosition';
  left: Maybe<Scalars['Float']['output']>;
  soldFilesWatermarkConfigPositionId: Maybe<Scalars['ID']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type StepPricing = {
  __typename?: 'StepPricing';
  firstStep: Maybe<Scalars['Int']['output']>;
  isFirstStepFree: Maybe<Scalars['Boolean']['output']>;
  lastStepPrice: Maybe<Array<Maybe<PriceConfig>>>;
  mode: Maybe<StepPricingMode>;
  steps: Maybe<Array<Maybe<PriceStep>>>;
};

export type StepPricingInput = {
  firstStep: Scalars['Int']['input'];
  isFirstStepFree: Scalars['Boolean']['input'];
  lastStepPrice: Array<InputMaybe<PriceConfigInput>>;
  mode: StepPricingMode;
  steps: Array<InputMaybe<PriceStepInput>>;
};

export enum StepPricingMode {
  Bundles = 'Bundles',
  ForAll = 'ForAll',
  ForOverTreshold = 'ForOverTreshold',
  None = 'None',
}

export type Subscription = {
  __typename?: 'Subscription';
  mockSub: Maybe<Scalars['ID']['output']>;
};

export type UpdateFilesConfig = {
  count: Scalars['Int']['input'];
  isFull: Scalars['Boolean']['input'];
  size: Scalars['Int']['input'];
};

export type UpdatePrintsCount = {
  count: Scalars['Int']['input'];
  printFormatId: Scalars['String']['input'];
  printPaperId: Scalars['String']['input'];
};

export type UpdateProductConfig = {
  config: Scalars['String']['input'];
  customName?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<ProductMode>;
  productId: Scalars['String']['input'];
  productInPackageId: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
};

export enum VatType {
  Applied = 'Applied',
  Exempt = 'Exempt',
}

export type WallDecorConfig = {
  __typename?: 'WallDecorConfig';
  config: Maybe<Scalars['String']['output']>;
  wallDecorConfigId: Maybe<Scalars['ID']['output']>;
};

export type WallDecorPieceForDisplay = {
  __typename?: 'WallDecorPieceForDisplay';
  WallDecorPieceForDisplayId: Maybe<Scalars['ID']['output']>;
  flip: Maybe<Scalars['Boolean']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  imageHeight: Maybe<Scalars['Int']['output']>;
  imageWidth: Maybe<Scalars['Int']['output']>;
  type: Maybe<WallDecorPieceForDisplayType>;
  wallDecorConfigId: Scalars['ID']['output'];
  width: Maybe<Scalars['Int']['output']>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export enum WallDecorPieceForDisplayType {
  Canvas = 'Canvas',
  Tambour = 'Tambour',
  ZalamoCalendar = 'ZalamoCalendar',
}

export type WallDecorSceneForDisplay = {
  __typename?: 'WallDecorSceneForDisplay';
  labs: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  pieces: Maybe<Array<Maybe<WallDecorPieceForDisplay>>>;
  wallDecorSceneForDisplayId: Maybe<Scalars['ID']['output']>;
};

export enum ZalamoObject {
  BookingPortfolio = 'BookingPortfolio',
  CompetitionEntry = 'CompetitionEntry',
  Conversation = 'Conversation',
  DesignerAsset = 'DesignerAsset',
  DigitalOrder = 'DigitalOrder',
  LegacyPrivateSessionFileOrder = 'LegacyPrivateSessionFileOrder',
  LookBookOrder = 'LookBookOrder',
  OldZalamoClient = 'OldZalamoClient',
  Order = 'Order',
  Organization = 'Organization',
  OrganizationClient = 'OrganizationClient',
  OrganizationPromoPrintFlyers = 'OrganizationPromoPrintFlyers',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  Product = 'Product',
  ProductInOrder = 'ProductInOrder',
  PublicSession = 'PublicSession',
  PublicSessionChildren = 'PublicSessionChildren',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionOrganization = 'PublicSessionOrganization',
  PublicSessionOrganizationGroup = 'PublicSessionOrganizationGroup',
  SupportThread = 'SupportThread',
  ZalamoPrintOrder = 'ZalamoPrintOrder',
}

export type ZalamoPrintSessionConfig = {
  __typename?: 'ZalamoPrintSessionConfig';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  calendarPrice: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  enabledTabloSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  magnetPrice: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  sellCalendar: Maybe<Scalars['Boolean']['output']>;
  sellMagnet: Maybe<Scalars['Boolean']['output']>;
  sellTablo: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tabloPricing: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  zalamoPrintSessionConfigId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionConfigInput = {
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  calendarPrice?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  enabledTabloSizes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  magnetPrice?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  sellCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sellMagnet?: InputMaybe<Scalars['Boolean']['input']>;
  sellTablo?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  tabloPricing?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
};

export type ZalamoPrintSessionTabloConfig = {
  __typename?: 'ZalamoPrintSessionTabloConfig';
  formatLabel: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  tabloIndex: Maybe<Scalars['Int']['output']>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionTabloPricingConfig = {
  __typename?: 'ZalamoPrintSessionTabloPricingConfig';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionTabloPricingConfigInput = {
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  zalamoPrintSizeId?: InputMaybe<Scalars['ID']['input']>;
};
